export default __webpack_public_path__ + "static/media/promo-4.bfad005d.png";